import React, { useEffect } from 'react';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const CompleteBearersPage = () => {
  const officeBearers = [
    {
      sno: 1,
      name: "Mr. M. N. Krishnamurthy",
      address: "#3c -910 HRBR,layout Kalyan Nagar Ist block. BANGALURU 560043",
      position: "President",
      contact: "krishnamurthymn19@gmail.com"
    },
    {
      sno: 2,
      name: "Sh. Ashok Sharma",
      address: "2/332, Kalakuan, Housing Board. Alwar-301001, Rajasthan",
      position: "Vice-President",
      contact: "ashok.advocate17@gmail.com"
    },
    {
      sno: 3,
      name: "Ms. Mitali Ghosh",
      address: "H.No. 243 Ward No.-38, Hemu Nagar, Bilaspur (Chhatisgarh) 495001",
      position: "Vice-President",
      contact: "cgabaseball@gmail.com"
    },
    {
      sno: 4,
      name: "Sh. S. Venkat",
      address: "No: 19, 3B, Quanta Ranjini apartments, Rajarathinam Street, Kilpauk, Chennai - 600010",
      position: "Vice-President",
      contact: "tnbachennai@yahoo.co.in"
    },
    {
      sno: 5,
      name: "Sh. S N Pradhan",
      address: "Tala- Telenga Bazar Purighat Cuttack - 753009 ODISHS",
      position: "Vice-President",
      contact: "baseballassociationofodisha@gmail.com"
    },
    {
      sno: 6,
      name: "Mr. Harish Kumar",
      address: "B - 19, 1st floor Sushant lok 2, Behind Police station,Sector - 56 Gurugram - 122011 (Haryana)",
      position: "Secretary General",
      contact: "abfi.secretarygeneral@gmail.com"
    },
    {
      sno: 7,
      name: "Sh. Jahar Dass",
      address: "11/11 Kalicharan Ghosh Road, Kalkata – 700050.",
      position: "Joint Secretary",
      contact: "jaharmumdas@hotmail.com"
    },
    {
      sno: 8,
      name: "Madhu Sharma",
      address: "Shyam Bhawan, Choudhary Tola, Patna 800006. Bihar",
      position: "Joint Secretary",
      contact: "madhusharma731959@gmail.com"
    },
    {
      sno: 9,
      name: "Shweta",
      address: "103,Dhani Apartments, 17-1-388/S/B & C Laxmi Nagar Colony Saidabad, Hyderabad- 500059",
      position: "Joint Secretary",
      contact: "baseballtelangana@gmail.com"
    },
    {
      sno: 10,
      name: "Mr. Virender Bhardwaj",
      address: "A- 401,PLOT NO 15B Maharani Aventi Bai Sector 22 Dwarka New Delhi - 110077",
      position: "Joint Secretary",
      contact: "virenbhardwaj29@gmail.com"
    },
    {
      sno: 11,
      name: "Dr. Dinesh Yadav",
      address: "901, metro suites society sector 4 vaishali ghaziabad (U. P)",
      position: "Treasurer",
      contact: "drdineshyadav1972@gmail.com"
    },
    {
      sno: 12,
      name: "Sh. Raju Shrama",
      address: "House no. 85 sector 1Bhagwati nagar canal road jammu J&K 180001",
      position: "Executive Member",
      contact: "beb83477@gmail.com"
    },
    {
      sno: 13,
      name: "Sh. Dilip Naik",
      address: "A-404, Konkar Nest, Near Agali Estate Housing Co-Op Society, Agali, Fatorda, Margao, Goa-403602",
      position: "Executive Member",
      contact: "dilipnaik0707@gmail.com"
    },
    {
      sno: 14,
      name: "Sh. Arvind Kumar",
      address: "Opp. 191-L, Model Town, Rohatk - 124001",
      position: "Executive Member",
      contact: "arvindku07@gmail.com"
    },
    {
      sno: 15,
      name: "Ms. Jasrita Purkayastha",
      address: "H.No. 111/1,Arju Nagar, Jail Road Lucknow 226005",
      position: "Executive Member",
      contact: "jasritapurkayastha@gmail.com"
    }
  ];

  useEffect(() => {
    document.title = 'Office Bearers | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        <div className="container" style={{ marginTop: '20px', marginBottom: '20px' }}>
          <h3 className="heading3">OFFICE BEARERS LIST</h3>
          
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Position</th>
                  <th>Contact</th>
                </tr>
              </thead>
              <tbody>
                {officeBearers.map((bearer) => (
                  <tr key={bearer.sno}>
                    <td>{bearer.sno}</td>
                    <td>{bearer.name}</td>
                    <td>{bearer.address}</td>
                    <td>{bearer.position}</td>
                    <td>
                      <a href={`mailto:${bearer.contact}`}>{bearer.contact}</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default CompleteBearersPage